import { z } from 'zod';
/**
 * Inbound webhook envelope accepted by POST /webhooks/event.
 *
 * The `event` field is the external event name (e.g. 'lead.received',
 * 'payment.overdue'). `data` is shape-agnostic at this layer; per-event
 * validation is applied by the registry entry for the given `event`.
 */
export const EventEnvelopeSchema = z.object({
    event: z.string().min(1),
    source: z.string().optional(),
    data: z.record(z.string(), z.unknown()),
});
//# sourceMappingURL=event-envelope.js.map